import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="resetFiltersHeader">
      <div class="customHeaderLabel">
        <b-button
          @click="onResetClicked"
          class="resetFiltersHeader-btn px-1 py-0"
          variant="primary"
          title="Сбросить фильтры и сортировку"
          style="height: 30px; width: 75px !important;"
        >
          Сброс <em class="fas fa-sort-amount-down" />
        </b-button>
      </div>
    </div>
  `,
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    onResetClicked() {
      this.params.context.componentParent.resetFilters()
    }
  }
})
